import React, { useContext, useEffect, useState, useRef } from "react";
import DashboardLayout from "../../../layouts/DashboardLayout/DashboardLayout";
import { Box, Button, Divider, Tooltip, Typography } from "@mui/material";
import FilterBox from "../../../components/FilterBox";
import BasicButtons from "../../../components/Button";
import PaginationTable from "../../../components/PaginationTable";
import "../../../scss/main.css";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";
import EditIcon from "@mui/icons-material/Edit";
import BlockIcon from "@mui/icons-material/Block";
import typographyStyles from "../../../theme/Typography";
import LoadingPage from "../LoadingPage/LoadingPage";
import Loading from "../../../components/Loading";

import VisibilityIcon from "@mui/icons-material/Visibility";

import {
  getDataHandlerWithToken,
  listCategory,
  putDataHandlerWithToken,
} from "../../../apiconfig/service";
import { saveAs } from "file-saver";
import BlockModal from "../../../Modal/BlockModal";
import toast from "react-hot-toast";
import DataNotFound from "../../../components/DataNotFound";

const columns = [
  { id: "sr_no", label: "Sr.No." },
  { id: "consult_name", label: "Consult's Name" },
  { id: "email", label: "Email" },
  { id: "created_date_time", label: "Created Date & Time" },
  { id: "action", label: "Action" },
];

const ConsultsListing = () => {
  const tableRef = useRef(null);
  const { isAuthenticated, user } = useContext(AuthContext);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [toggle, setToggle] = useState(false); // State to trigger re-render
  const [blockModalOpen, setBlockModalOpen] = useState(false);
  const [blockId, setBlockId] = useState(null);
  const [status, setStatus] = useState();
  const [name, setName] = useState();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(Number.MAX_SAFE_INTEGER);
  const [totalDocs, setTotalDocs] = useState("");

  useEffect(() => {
    const fetchServices = async () => {
      if (isAuthenticated && user) {
        try {
          const params = {
            page: page + 1,
            limit: rowsPerPage,
          };
          console.log(params);
          const response = await getDataHandlerWithToken("listConsult", params);
          setData(response.result.docs);
          console.log(response.result.docs);
          setTotalDocs(response.result.totalDocs);
          setFilteredData(response.result.docs); // Initially, all data is filtered data
          setLoading(false);
        } catch (error) {
          console.error("Error fetching categories:", error);
          setLoading(false);
        }
      }
    };

    fetchServices();
  }, [isAuthenticated, user, toggle, page, rowsPerPage]);

  const handleEdit = (id) => {
    navigate(`/consults/editConsult/${id}`);
  };
  const handleBlock = (id, name, status) => {
    setBlockId(id);
    setStatus(status == "ACTIVE" ? "BLOCK" : "ACTIVE");
    setName(name);
    setBlockModalOpen(true);
    console.log(id);
  };

  const handleBlockConfirm = async () => {
    let id = blockId;
    try {
      const res = await putDataHandlerWithToken(
        "blockUnblockConsult",
        {},
        { consultId: id }
      );
      if (res.responseCode === 200) {
        setToggle((prevToggle) => !prevToggle);
        setBlockModalOpen(false);
        console.log("blocked");
        toast.success(res.responseMessage);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleBlockCancel = () => {
    setBlockModalOpen(false);
  };

  const handleFilterChange = (filterCriteria) => {
    let filtered = [...data]; // Clone the original data to avoid modifying it directly
    console.log("Filter criteria:", filterCriteria);
  
    // Function to parse custom date object into JavaScript Date
    const parseCustomDate = (customDate) => {
      if (!customDate || !customDate.$y) return null; // Ensure the date is valid
      const year = customDate.$y;
      const month = customDate.$M; // Months are 0-indexed
      const day = customDate.$D;
      const hours = customDate.$H || 0; // Defaults to 0 if hours are not present
      const minutes = customDate.$m || 0; // Defaults to 0 if minutes are not present
      const seconds = customDate.$s || 0; // Defaults to 0 if seconds are not present
      return new Date(year, month, day, hours, minutes, seconds);
    };
  
    // Filter by search text
    if (filterCriteria.searchText) {
      filtered = filtered.filter((item) =>
        item.consultName
          .toLowerCase()
          .includes(filterCriteria.searchText.toLowerCase().trim())
      );
      console.log("After search filter:", filtered);
    }
  
    // Filter by fromDate
    if (filterCriteria.fromDate) {
      const fromDate = parseCustomDate(filterCriteria.fromDate);
      if (fromDate) {
        filtered = filtered.filter((item) => {
          const createdAtDate = new Date(item.createdAt);
          return createdAtDate >= fromDate;
        });
        console.log("After fromDate filter:", filtered);
      }
    }
  
    // Filter by toDate
    if (filterCriteria.toDate) {
      const toDate = parseCustomDate(filterCriteria.toDate);
      if (toDate) {
        filtered = filtered.filter((item) => {
          const createdAtDate = new Date(item.createdAt);
          return createdAtDate <= toDate;
        });
        console.log("After toDate filter:", filtered);
      }
    }
  
    // Filter by selectedValue (stage)
    if (
      filterCriteria.selectedValue &&
      filterCriteria.selectedValue !== "All"
    ) {
      filtered = filtered.filter(
        (item) => item.stage === filterCriteria.selectedValue
      );
      console.log("After stage filter:", filtered);
    }
  
    // Filter by recipeType
    if (
      filterCriteria.recipeType &&
      filterCriteria.recipeType !== "All"
    ) {
      filtered = filtered.filter(
        (item) => item.recipeType === filterCriteria.recipeType
      );
      console.log("After recipeType filter:", filtered);
    }
  
    // Filter by status
    if (
      filterCriteria.status &&
      filterCriteria.status !== "All"
    ) {
      filtered = filtered.filter(
        (item) => item.status === filterCriteria.status
      );
      console.log("After status filter:", filtered);
    }
  
    // Filter by country
    if (
      filterCriteria.country &&
      filterCriteria.country !== "All"
    ) {
      filtered = filtered.filter(
        (item) => item.country === filterCriteria.country
      );
      console.log("After country filter:", filtered);
    }
  
    // Update state with filtered data
    setFilteredData(filtered);
    console.log("Final filtered data:", filtered);
  };
  

  const downloadCSV = () => {
    const table = tableRef.current;
    const rows = Array.from(table.querySelectorAll("tr"));

    const csvData = rows
      .map((row) => {
        const cols = Array.from(row.querySelectorAll("td, th"));
        return cols.map((col) => col.textContent).join(",");
      })
      .join("\n");

    const blob = new Blob([csvData], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.setAttribute("hidden", "");
    
    // Get the current date and format it as needed
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().split('T')[0]; // YYYY-MM-DD format
    const fileName = `Consult_List_${formattedDate}.csv`;

    a.setAttribute("href", url);
    a.setAttribute("download", fileName);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
};


  const handlePageChange = (newPage, newRowsPerPage) => {
    setPage(newPage);
    setRowsPerPage(newRowsPerPage);
  };

  return (
    <DashboardLayout>
      <Box className="category-container">
        <Box className="heading-container-top">
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography sx={{ ...typographyStyles.h4 }}>Consults</Typography>
          </Box>

          {/* {showBackButtonSection && (
                            <Box sx={dashboardLayoutStyle.titleSection}>
                            <img
                                src={backBtn}
                                alt="backBtn"
                                style={{
                                    width: "2.813",
                                    height: "2.813",
                                    cursor: "pointer",
                                }}
                                onClick={() => Navigate(-1)}
                            />
                            <Typography sx={dashboardLayoutStyle.sectionTitle}>{title}</Typography>
                        </Box>
                        )} */}
          <Box className="button-container">
            <Box className="button-sub-container">
              <BasicButtons text="Download CSV" onClick={downloadCSV} />
              <BasicButtons
                text="+Add Consults"
                onClick={() => navigate("/consults/addConsults")}
              />
            </Box>
          </Box>
        </Box>
        <Divider />

        <Box className="filter-container">
          <FilterBox
            placeholder="Search by consult name"
            onFilterChange={handleFilterChange}
            dropdownNone={"none"}
            showStatusDropdown = {true}
            showCountryDropdown={true}
          />
        </Box>

        <Box className="table-container">
          {loading ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "50vh", // Adjust height as needed
              }}
            >
              <Loading />
            </Box>
          ) : filteredData?.length < 1 ? (
            <DataNotFound />
          ) : (
            <PaginationTable
              ref={tableRef}
              columns={columns}
              totalDocs={totalDocs}
              data={filteredData.map((row, index) => ({
                sr_no: index + 1,
                consult_name: (
                  <Tooltip title={row.consultName} arrow>
                    <span>
                      {row.consultName?.length > 20
                        ? `${row.consultName?.substring(0, 20)}...`
                        : row.consultName}
                    </span>
                  </Tooltip>
                ),
                email: (
                  <Tooltip title={row.email} arrow>
                    <span>
                      {row.email?.length > 20
                        ? `${row.email.substring(0, 20)}...`
                        : row.email}
                    </span>
                  </Tooltip>
                ),

                created_date_time: new Date(row.createdAt).toLocaleString(
                  "en-US",
                  {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                    hour: "numeric",
                    minute: "numeric",

                    hour12: true,
                  }
                ),
                action: (
                  <Box className="row-button-container" sx={{ gap: "15%" }}>
                    <VisibilityIcon
                      variant="outlined"
                      onClick={() => navigate(`viewConsult/${row._id}`)}
                      sx={{
                        color: "rgb(225,140,168)",
                        borderColor: "rgb(225,140,168)",
                        cursor: "pointer",
                      }}
                    />
                    <EditIcon
                      onClick={() => handleEdit(row._id)}
                      sx={{
                        color: "rgb(225,140,168)",
                        borderColor: "rgb(225,140,168)",
                        fontFamily: "'Poppins', sans-serif",
                        cursor: "pointer",
                      }}
                    />
                    <BlockIcon
                      onClick={() =>
                        handleBlock(row._id, row.consultName, row.status)
                      }
                      sx={{
                        color: row.status == "ACTIVE" ? "green" : "red",
                        borderColor: "rgb(225,140,168)",
                        fontFamily: "'Poppins', sans-serif",
                        cursor: "pointer",
                      }}
                    />
                  </Box>
                ),
              }))}
              onPageChange={handlePageChange}
            />
          )}
        </Box>
      </Box>
      {blockModalOpen && (
        <BlockModal
          title="CONSULT"
          status={status}
          name={name}
          onClose={handleBlockCancel}
          onBlock={handleBlockConfirm}
        />
      )}
    </DashboardLayout>
  );
};

export default ConsultsListing;
